import { Category, useStores } from 'src/models';
import { commonApi } from 'src/services';

/**
 * 서비스 제어
 * 서비스 상태 확인 후 알림을 표시하거나 원래의 클릭 이벤트를 실행하는 훅
 */

export const useClickTracking = () => {
  const { snackbarStore, alertStore } = useStores();

  // 서비스 제어 확인 함수
  const checkServiceControl = async (
    pagePath: string,
    onClick?: VoidFunction | undefined,
  ): Promise<boolean> => {
    try {
      const result = await commonApi.getServiceControl(pagePath);
      if (result?.resultCode === 'S') {
        const serviceControl = result.data;
        if (serviceControl?.serviceUseYn === 'N') {
          // 서비스 이용 불가
          snackbarStore.setProps({
            open: true,
            category: Category.Error,
            title: serviceControl.serviceMsg,
          });
          return false; // 서비스 비활성화 상태
        } else if (serviceControl?.serviceUseYn === 'Y') {
          // 서비스 이용은 가능하나 공지사항이 있는 경우
          if (onClick && serviceControl?.alertYn === 'Y') {
            alertStore.setProps({
              open: true,
              title: serviceControl.alertMsg,
            });
            alertStore.setOnClick(() => {
              onClick();
              alertStore.closeAlert();
            });

            return false;
          }
        }
      }
      return true; // 서비스 활성화 상태 또는 API 응답 실패
    } catch (error) {
      console.error('service control error: ', error);
      return true; // 오류 발생 시 기본적으로 계속 진행
    }
  };

  // 일반 클릭 트래킹
  const withTracking = (pagePath: string, originalOnClick?: () => void) => {
    return async () => {
      const shouldContinue = await checkServiceControl(pagePath, originalOnClick);
      if (shouldContinue && originalOnClick) {
        originalOnClick();
      }
    };
  };

  return { withTracking };
};
